// extracted by mini-css-extract-plugin
export default {"resetPasswordMessage":"ResetPasswordMessage_resetPasswordMessage__leFPl","linkButton":"ResetPasswordMessage_linkButton__ob-U3"};